export const normalizeToMonthly = (amount, frequency) => {
  const map = { 
    'daily': 365/12, 
    'weekly': 52/12, 
    'bi-weekly': 26/12, 
    'monthly': 1, 
    'quarterly': 1/3, 
    'semi-annually': 1/6, 
    'annually': 1/12 
  };
  return (amount || 0) * (map[frequency || 'monthly'] || 1);
};

// --- NEW HELPER: Fixes the "0.00000001" floating point math issues ---
export const roundMoney = (amount) => {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
};

export const formatCurrency = (val) => {
  return new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency: 'USD', 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }).format(val || 0);
};

// Timezone-safe date formatter
export const formatDate = (dateInput) => {
    if (!dateInput) return "";
    
    // If it's already a date object
    if (dateInput instanceof Date) {
         return dateInput.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    // If string, prevent timezone shifts by manually parsing components
    if (typeof dateInput === 'string') {
        const cleanDate = dateInput.split('T')[0]; 
        if(cleanDate.includes('-')) {
             const [y, m, d] = cleanDate.split('-').map(Number);
             // Create date using local constructor with these exact components
             const dateObj = new Date(y, m - 1, d); 
             return dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        }
    }
    return "";
};